import React from "react";
import { Rocket, ShieldCheck, Truck } from "lucide-react";
import StorefrontHeader from "../components/StorefrontHeader";
import { StorefrontList } from "./Storefront";
import useEmbedResize from "../hooks/useEmbedResize";

/**
 * Dedicated pre-orders page. Same grid + card design as /storefront/launches,
 * but filtered to campaigns that have already crossed the vote threshold
 * (status === "pre_order"). Voting products live on /storefront.
 */
export default function StorefrontPreorders() {
  useEmbedResize();
  return (
    <div className="dc-store min-h-screen" data-testid="storefront-preorders-page">
      <StorefrontHeader active="preorders" />

      <div className="max-w-6xl mx-auto px-6 md:px-10 pt-10 md:pt-16 pb-2">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest text-[#5B4FE0] font-semibold">
            <Rocket size={12} /> Pre-orders open
          </div>
          <h1 className="text-3xl sm:text-5xl font-semibold tracking-tight mt-3 leading-tight text-[#111]">
            Community-launched drops.
          </h1>
          <p className="text-base sm:text-lg text-[#6D7175] mt-4 leading-relaxed">
            These products crossed the vote threshold — pre-orders are open and shipping to backers first.
            Limited units, first come first served.
          </p>
          <div className="mt-6 flex items-center gap-4 text-xs text-[#6D7175] flex-wrap">
            <span className="inline-flex items-center gap-1.5"><ShieldCheck size={12} className="text-[#5B4FE0]" /> Backers ship first</span>
            <span className="inline-flex items-center gap-1.5"><Truck size={12} /> Ships when the drop closes</span>
          </div>
        </div>
      </div>

      <div className="-mt-2" data-testid="preorders-list">
        <StorefrontList statusFilter="pre_order" />
      </div>
    </div>
  );
}
